"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;
/**
 * The standard colors available to designs in Ursa a.k.a. New Views a.k.a. Smartsheet Design
 * System.
 */
const colors = {
  /**
   * Global
   */
  focus: "#1F66FF",
  linkDark: "#0F3B99",
  linkDefault: "#1957DE",
  /**
   * Aqua
   */
  aqua25: "#F1F8F9",
  aqua50: "#E0EFF2",
  aqua75: "#BEDEE4",
  aqua100: "#A1CFD8",
  aqua200: "#80BECB",
  aqua300: "#4DA4B6",
  aqua400: "#008CA8",
  aqua500: "#007B94",
  aqua600: "#00667A",
  aqua700: "#004452",
  aqua800: "#002B33",
  aqua900: "#001A1F",
  /**
   * Azure
   */
  azure25: "#F1F9FE",
  azure50: "#E3F3FD",
  azure75: "#CAE8FC",
  azure100: "#ADDBFA",
  azure200: "#90CFF9",
  azure300: "#63BCF8",
  azure400: "#35A1E9",
  azure500: "#198FDE",
  azure600: "#027ED1",
  azure700: "#015892",
  azure800: "#002E4D",
  azure900: "#001F33",
  /**
   * Blue - brand color and semantic color for info
   */
  blue25: "#F1F5FE",
  blue50: "#E3EBFD",
  blue75: "#CADAFC",
  blue100: "#ADC6FA",
  blue200: "#90B1F9",
  blue300: "#6392F8",
  blue400: "#356EE9",
  blue500: "#1957DE",
  blue600: "#0244D1",
  blue700: "#012F92",
  blue800: "#00184D",
  blue900: "#001033",
  /**
   * Neutral
   */
  neutral00: "#FFFFFF",
  neutral25: "#F5F6FA",
  // same as slate25, yes that's intentional.
  neutral35: "#EEF0F6",
  neutral50: "#E6E8EF",
  neutral60: "#DCDEE8",
  neutral75: "#D0D3E0",
  neutral100: "#B9BDCC",
  neutral200: "#A8ACBD",
  neutral300: "#9094A7",
  neutral400: "#71768A",
  neutral500: "#63687D",
  neutral600: "#4E5366",
  neutral700: "#393D4C",
  neutral800: "#242732",
  neutral900: "#11131C",
  /**
   * Gold
   */
  gold25: "#FFFAF0",
  gold50: "#FFF5E0",
  gold75: "#FFEECC",
  gold100: "#FFE2A8",
  gold200: "#FFD580",
  gold300: "#FFC44D",
  gold400: "#FFBD38",
  gold500: "#FFB41F",
  gold600: "#F0A000",
  gold700: "#CC7E00",
  gold800: "#8F4500",
  gold900: "#4C1D00",
  /**
   * Green - semantic color for success
   */
  green25: "#F3F9F1",
  green50: "#E5F2E0",
  green75: "#C7E3BB",
  green100: "#ACD59A",
  green200: "#96CB80",
  green300: "#6DB64D",
  green400: "#3CA210",
  green500: "#37950F",
  green600: "#247900",
  green700: "#174D00",
  green800: "#0E2E00",
  green900: "#081A00",
  /**
   * Indigo
   */
  indigo25: "#F4F1FE",
  indigo35: "#F0ECFE",
  indigo50: "#E9E3FD",
  indigo75: "#D6CAFC",
  indigo100: "#C0ADFA",
  indigo200: "#AA90F9",
  indigo300: "#906DF8",
  indigo400: "#7047EB",
  indigo500: "#5B2CE8",
  indigo600: "#4517CF",
  indigo700: "#321197",
  indigo800: "#1D0A57",
  indigo900: "#0F052E",
  /**
   * Mint
   */
  mint25: "#F1F9F3",
  mint50: "#E0F2E4",
  mint75: "#BEE4C8",
  mint100: "#A1D8AF",
  mint200: "#80CB93",
  mint300: "#4DB667",
  mint400: "#08A02E",
  mint500: "#088E29",
  mint600: "#067321",
  mint700: "#044915",
  mint800: "#02270B",
  mint900: "#001A06",
  /**
   * Orange - semantic color for warning
   */
  orange25: "#FDF5F1",
  orange50: "#FCEBE4",
  orange75: "#FADDD1",
  orange100: "#FBC8B2",
  orange200: "#FCAA87",
  orange300: "#F98F62",
  orange400: "#F07642",
  orange500: "#E2632C",
  orange600: "#CB480F",
  orange700: "#902F06",
  orange800: "#611D00",
  orange900: "#330F00",
  /**
   * Orchid
   */
  orchid25: "#FBF4FB",
  orchid50: "#F6E7F6",
  orchid75: "#EED2EE",
  orchid100: "#E5B8E5",
  orchid200: "#DE9ADE",
  orchid300: "#D978D9",
  orchid400: "#D454D4",
  orchid500: "#CE3BCE",
  orchid600: "#B021B0",
  orchid700: "#8C0D8C",
  orchid800: "#570057",
  orchid900: "#330033",
  /**
   * Pink
   */
  pink25: "#FDF1F5",
  pink50: "#FCE4EC",
  pink75: "#FAD1DF",
  pink100: "#F7B5CB",
  pink200: "#F48FB1",
  pink300: "#F16A97",
  pink400: "#E54D80",
  pink500: "#DA346C",
  pink600: "#C21851",
  pink700: "#880E37",
  pink800: "#5C0522",
  pink900: "#28010E",
  /**
   * Red - semantic color for error
   */
  red25: "#FDF1F2",
  red50: "#FCE4E6",
  red75: "#FAD1D4",
  red100: "#F7B5B9",
  red200: "#F48F96",
  red300: "#F16A73",
  red400: "#E54D57",
  red500: "#DA343F",
  red600: "#C21823",
  red700: "#880E16",
  red800: "#5C050B",
  red900: "#280104",
  /**
   * Rose
   */
  rose25: "#FBF4F7",
  rose50: "#F6E7EE",
  rose75: "#F0D6E3",
  rose100: "#E5B8CF",
  rose200: "#DD9ABC",
  rose300: "#D171A1",
  rose400: "#C14E87",
  rose500: "#B12F70",
  rose600: "#A12161",
  rose700: "#830C47",
  rose800: "#5C0530",
  rose900: "#280114",
  /**
   * Slate - brand color for canvas and global nav
   */
  slate25: "#F5F6FA",
  slate35: "#EEF0F6",
  slate50: "#E5E7F1",
  slate60: "#DBDDEB",
  slate75: "#D1D5E6",
  slate100: "#B6BDD8",
  slate200: "#A2ABCD",
  slate300: "#8792BF",
  slate400: "#6674AD",
  slate500: "#5665A1",
  slate600: "#41508B",
  slate700: "#2E3A6B",
  slate800: "#1C254A",
  slate900: "#0D1226",
  /**
   * Teal
   */
  teal25: "#F1F9F8",
  teal50: "#E0F2F1",
  teal75: "#BEE4E1",
  teal100: "#A1D8D3",
  teal200: "#80CBC5",
  teal300: "#4DB6AD",
  teal400: "#00A89A",
  teal500: "#009689",
  teal600: "#00796F",
  teal700: "#004D47",
  teal800: "#00332F",
  teal900: "#001A17",
  /**
   * Violet
   */
  violet25: "#F8F4FB",
  violet50: "#EFE7F6",
  violet75: "#E2D2EE",
  violet100: "#D1B8E5",
  violet200: "#C09ADE",
  violet300: "#AF78D9",
  violet400: "#9D4EDA",
  violet500: "#8F35D4",
  violet600: "#731AB7",
  violet700: "#550D8C",
  violet800: "#310057",
  violet900: "#1D0033",
  /**
   * Yellow
   */
  yellow25: "#FFFCEB",
  yellow50: "#FFFAE0",
  yellow75: "#FFF7CC",
  yellow100: "#FFF1A8",
  yellow200: "#FFEA80",
  yellow300: "#FFE14D",
  yellow400: "#FFD91A",
  yellow500: "#FAD000",
  yellow600: "#EBC400",
  yellow700: "#CCA000",
  yellow800: "#8F5D00",
  yellow900: "#4C2A00"
};
exports.colors = colors;
//# sourceMappingURL=ursaColors.js.map